import { gql } from "@apollo/client";
export const CompaniesFind = gql `
  query CompaniesFind($query: QueryInput) {
    CompaniesFind(query: $query) {
      _id
      name
    }
  }
`;
